import { render, staticRenderFns } from "./ShopStoreRanking.vue?vue&type=template&id=572929ca&scoped=true"
import script from "./ShopStoreRanking.vue?vue&type=script&lang=js"
export * from "./ShopStoreRanking.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "572929ca",
  null
  
)

export default component.exports